var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreesGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.27 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.07,91.76l-17.63-52.6c-.36-1.06-1.21-1.91-2.27-2.27-1.9-.65-3.96.37-4.61,2.28l-5.99,17.86L58.52,3.13c-.45-1.36-1.54-2.45-2.9-2.9-2.39-.79-4.98.51-5.76,2.86l-19.05,53.93-5.98-17.84c-.29-.93-.93-1.68-1.79-2.13-.86-.45-1.85-.53-2.77-.24-1.13.36-2.01,1.24-2.36,2.33L.18,91.81c-.37,1.2-.16,2.5.55,3.46.61.83,1.53,1.3,2.52,1.3h16.45v5.43c0,1.1.9,2,2,2s2-.9,2-2v-5.43h15.71c.68,0,1.33-.33,1.73-.88.34-.46,1.07-1.5-.84-8.05h12.08v14.36c0,1.1.9,2,2,2s2-.9,2-2v-14.25h11.68c-1.84,6.55-1.3,7.3-.81,7.96.41.55,1.03.87,1.71.87h16.1v5.43c0,1.1.9,2,2,2s2-.9,2-2v-5.43h15.97c1,0,1.92-.48,2.53-1.32.71-.97.89-2.27.5-3.49ZM53.64,4.39c.1-.3.42-.46.72-.36.17.06.31.19.38.4l27.69,78.36c.13.4.02.79-.08.96h-10.71c-.08-.04-.17-.08-.26-.11-.49-.15-1-.09-1.43.11h-15.1c-.21-.07-.43-.11-.65-.11h-16.05c-.36-.11-.76-.11-1.14,0h-10.94c-.1-.16-.21-.53-.09-.89L53.64,4.39ZM37.38,92.57H4.14l17.22-51.13,7.28,21.72-6.47,18.31c-.5,1.55-.25,3.3.67,4.56.74,1.02,1.84,1.61,3.02,1.61h10.25c.45,1.55.98,3.54,1.27,4.93ZM70.99,92.57c.26-1.26.73-3.06,1.23-4.82h10.33c1.16,0,2.24-.58,2.98-1.58.92-1.26,1.2-3.01.69-4.63l-6.49-18.38,7.27-21.68,17.12,51.09h-33.13Z",
    fill: "#2cc749"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreesGreen);
export default __webpack_public_path__ + "static/media/trees-green.08decd735556c68b3d9432ce662b9e99.svg";
export { ForwardRef as ReactComponent };